import React from 'react';
import StatusFilter from './StatusFilter';

interface SearchBarProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  placeholder: string;
  statusFilters: string[];
  setStatusFilters: (filters: string[]) => void;
  statusDropdownOpen: boolean;
  setStatusDropdownOpen: (open: boolean) => void;
  showStatusFilter?: boolean;
  filterType?: 'task' | 'project';
  className?: string;
  parentClassName?: string;
  statusCounts?: Record<string, number>;
}

const SearchBar: React.FC<SearchBarProps> = ({
  searchValue,
  onSearchChange,
  placeholder,
  statusFilters,
  setStatusFilters,
  statusDropdownOpen,
  setStatusDropdownOpen,
  showStatusFilter = true,
  filterType = 'project',
  className,
  parentClassName,
  statusCounts
}) => {
  return (
    <div className={` py-1 w-full ${parentClassName}`}>
      <div
        className={`flex items-center ${className} border border-light-border-default dark:border-slate-800 rounded-xl bg-light-input-bg dark:bg-tertiary-dark shadow-sm hover:shadow-md transition-all duration-200 focus-within:border-light-border-focus focus-within:ring-2 focus-within:ring-primary-light/20 focus:outline-none `}
        style={{ minHeight: 44 }}
      >
        {showStatusFilter && (
          <>
            <StatusFilter
              statusFilters={statusFilters}
              setStatusFilters={setStatusFilters}
              isOpen={statusDropdownOpen}
              setIsOpen={setStatusDropdownOpen}
              filterType={filterType}
              statusCounts={statusCounts}
            />
            <div className="h-6 w-px bg-light-border-subtle dark:bg-gray-700" />
          </>
        )}
        <input
          type="text"
          className="flex-1 bg-transparent font-normal  text-light-text-primary dark:text-gray-300 px-3 py-2 focus:outline-none focus:ring-0 placeholder:text-light-input-placeholder dark:placeholder-gray-400 border-none min-w-0 text-xs"
          placeholder={placeholder}
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
    </div>
  );
};

export default SearchBar; 